import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import BookmarkViews from './views';


class Bookmark extends Component {
  constructor(props) {
    super(props);
  }

  handleClick = () => {
    const {
      bookmarks, createBookmark, deleteBookmark,
      currentPageBreak:currentPage
    } = this.props;

    const selectedBookmark = bookmarks.find(bookmark => {
      return bookmark.page === currentPage;
    });

    if (selectedBookmark) {
      deleteBookmark(selectedBookmark.id);
    } else {
      createBookmark();
    }
  }

  isPageBookmarked = () => {
    const { bookmarks, currentPageBreak:currentPage } = this.props;

    const matchingBookmarks = bookmarks.filter(bookmark => {
      return bookmark.page === currentPage;
    });

    return matchingBookmarks.length > 0;
  }

  render() {
    const viewItems = {
      handleClick: this.handleClick,
      isBookmarked: this.isPageBookmarked()
    };

    return <BookmarkViews { ...viewItems } />;
  }
}

Bookmark.propTypes = {
  bookmarks: PropTypes.array
};

function mapStateToProps(state) {
  const { bookmarks, currentPageBreak } = state;

  return {
    bookmarks,
    currentPageBreak
  };
}


export default connect(mapStateToProps, {})(Bookmark);
